import { useState } from "react";
import { useHistory } from "react-router-dom";
import { OpenAuthSupportTicket, setAuthSupportInfo } from "../actions/auth";
import { setIsInert } from "../actions/global";
import { ROUTES } from "../constants/clientRoutes";
import { PAGES } from "../constants/localization";
import { toErrorObjs } from "../services/formatter";
import { useAppDispatch } from "../store/hooks";
import { ErrorObj } from "../types/errors";

interface UseAuthSupportTicketArgs {
  category: string;
  ticketTitle: string;
  description?: string;
}

export const useAuthSupportTicket = ({
  category,
  ticketTitle,
  description = PAGES.AUTH.SUPPORT.REQUEST_DESCRIPTION,
}: UseAuthSupportTicketArgs) => {
  const dispatch = useAppDispatch();
  const history = useHistory();

  const [submitting, setSubmitting] = useState(false);
  const [errors, setErrors] = useState<ErrorObj[] | null>(null);

  const reset = () => setErrors(null);

  const submitTicket = async () => {
    setSubmitting(true);
    setErrors(null);

    try {
      const data: any = await dispatch(
        (OpenAuthSupportTicket as any)(category, null, description)
      );

      if (!data.supportTicketCreated) {
        throw new Error(
          data.activeTicketInCategory
            ? PAGES.AUTH.SUPPORT.TICKET_ALREADY_OPENED
            : PAGES.AUTH.SUPPORT.TICKET_NOT_CREATED
        );
      }

      dispatch((setIsInert as any)(false));
      dispatch(
        (setAuthSupportInfo as any)({
          title: ticketTitle,
          subtitle: PAGES.AUTH.SUPPORT.TICKET_SUBMITTED,
          ticketInfo: `${PAGES.AUTH.SUPPORT.TICKET_NO} ${data.ticketNumber}`,
          content: `<p>${PAGES.AUTH.SUPPORT.EMAIL_CONFIRMATION}</p><p><b>${data.email}</b></p>`,
          showCannotAccessEmail: true,
          category,
        })
      );

      history.push(ROUTES.AUTH.SUPPORT);
    } catch (error) {
      const responseErrors = (error as any)?.response?.data?.errors;
      setErrors(responseErrors ?? toErrorObjs(error));
      setSubmitting(false);
    }
  };

  return { submitTicket, submitting, errors, reset };
};